import { Heading } from '@periodica/ui-kit';
import React, { type PropsWithChildren } from 'react';

import styles from './GiftForm.module.scss';

export function FormBlockHeading({ children }: PropsWithChildren) {
  return (
    <Heading variant="h2" className={styles.h3}>
      {children}
    </Heading>
  );
}
